{
  "lastUpdatedAt": "2026-10-26T16:13:33.572Z",
  "lastFetchAttemptAt": "2026-10-26T16:13:33.572Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}